// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Common styles for listen subpages */
.section-title.blue {
  color: #0074b3 !important;
}

form {
  text-align: left;
}

form input[type="text"],
form input[type="number"],
form input[type="date"],
form input[type="time"],
form textarea {
  background-color: rgba(180, 200, 130, 0.5);
  border: none;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  color: gray;
  font-size: 1rem;
  font-family: 'Circular', sans-serif;
  margin-bottom: 15px;
}

form textarea {
  color: #648202;
}

.checkbox-container {
  margin-top: 10px;
  text-align: left;
}

.checkbox-container label {
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}

.checkbox-container input[type="checkbox"] {
  margin-right: 10px;
  accent-color: var(--dunkelgruen);
}

/* High contrast placeholder text */
form input::placeholder {
  color: var(--primary-dark);
  opacity: 1;
}

/* Print link section below tables */
.print-strip {
  color: #00509E !important;
  padding: 10px 0;
  text-align: center;
}

.print-link {
  color: #00509E !important;
  text-decoration: none;
  font-weight: normal;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.print-link .print-text {
  color: #00509E !important;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.print-link .material-symbols-outlined {
  margin-right: 0.25rem;
  color: #00509E;
  font-variation-settings:
    'FILL' 0,
    'wght' 500,
    'GRAD' 0,
    'opsz' 40;
}

.delete-icon {
  color: var(--blutorange);
  cursor: pointer;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table-header .print-link {
  margin-left: auto;
}

@media (max-width: 600px) {
  .section-title.blue {
    font-size: 2.5rem !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/listen/ListenSubpage.css"],"names":[],"mappings":"AAAA,sCAAsC;AAEtC;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;EAKE,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;EACf,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,mCAAmC;AACnC;EACE,0BAA0B;EAC1B,UAAU;AACZ;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd;;;;aAIW;AACb;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF","sourcesContent":["/* Common styles for listen subpages */\n@import '../styles/variables.css';\n.section-title.blue {\n  color: #0074b3 !important;\n}\n\nform {\n  text-align: left;\n}\n\nform input[type=\"text\"],\nform input[type=\"number\"],\nform input[type=\"date\"],\nform input[type=\"time\"],\nform textarea {\n  background-color: rgba(180, 200, 130, 0.5);\n  border: none;\n  padding: 10px;\n  border-radius: 5px;\n  width: 100%;\n  color: gray;\n  font-size: 1rem;\n  font-family: 'Circular', sans-serif;\n  margin-bottom: 15px;\n}\n\nform textarea {\n  color: #648202;\n}\n\n.checkbox-container {\n  margin-top: 10px;\n  text-align: left;\n}\n\n.checkbox-container label {\n  margin-bottom: 5px;\n  display: flex;\n  align-items: center;\n}\n\n.checkbox-container input[type=\"checkbox\"] {\n  margin-right: 10px;\n  accent-color: var(--dunkelgruen);\n}\n\n/* High contrast placeholder text */\nform input::placeholder {\n  color: var(--primary-dark);\n  opacity: 1;\n}\n\n/* Print link section below tables */\n.print-strip {\n  color: #00509E !important;\n  padding: 10px 0;\n  text-align: center;\n}\n\n.print-link {\n  color: #00509E !important;\n  text-decoration: none;\n  font-weight: normal;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n}\n\n.print-link .print-text {\n  color: #00509E !important;\n  text-decoration: underline;\n  text-underline-offset: 4px;\n}\n\n.print-link .material-symbols-outlined {\n  margin-right: 0.25rem;\n  color: #00509E;\n  font-variation-settings:\n    'FILL' 0,\n    'wght' 500,\n    'GRAD' 0,\n    'opsz' 40;\n}\n\n.delete-icon {\n  color: var(--blutorange);\n  cursor: pointer;\n}\n\n.table-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.table-header .print-link {\n  margin-left: auto;\n}\n\n@media (max-width: 600px) {\n  .section-title.blue {\n    font-size: 2.5rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
